import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserSettings } from "../modules/stores/interfaces/UserSettings";
import { UserSettingsState } from "../modules/stores/interfaces/UserSettingsState";

const initialState: UserSettingsState = {
    keyboardSound: true,
};

const userSettingsSlice = createSlice({
    name: "userSettings",
    initialState,
    reducers: {
        toggleKeyboardSound: (state) => {
            state.keyboardSound = !state.keyboardSound;
        },
    }
});

export const { toggleKeyboardSound } = userSettingsSlice.actions;
export type { UserSettings } from "../modules/stores/interfaces/UserSettings";
export default userSettingsSlice.reducer;
